
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nearby_resorts",
      function () {
        return require("private-next-pages/nearby_resorts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nearby_resorts"])
      });
    }
  